'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'

import { Modal } from 'base-ui'

import { DrawerTransition } from '../../../drawer-transition'
import { type OpenableControls } from '../../../generic-hooks'

import { DynamicSellerModalContent } from './SellerModalContent/DynamicSellerModalContent'

import styles from './SellerModal.module.css'

type SellerModalProps = {
  openableControls: OpenableControls
}

export const SellerModal: FC<SellerModalProps> = ({ openableControls }) => (
  <Modal
    className={clsx(
      styles['seller-modal'],
      'flex flex-col items-end justify-end rounded-l-m',
    )}
    closeAfterTransition
    data-qa-id="seller-dialog"
    onClose={openableControls.handleClose}
    open={openableControls.isOpen}
  >
    <DrawerTransition
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      className="mt-[120px] flex h-dvh w-full flex-col overflow-y-auto rounded-t-m bg-light-primary-medium tablet:mt-0 tablet:max-w-screen-tablet tablet:rounded-l-m tablet:rounded-tr-none"
      in={openableControls.isOpen}
    >
      <DynamicSellerModalContent />
    </DrawerTransition>
  </Modal>
)
